import { action } from 'easy-peasy';
import { IActionRemoveCrisisCallTeamMemberAllocations } from '../types';
import { getAllocationClientId, removeAllocations } from './helpers';

const removeCrisisCallTeamMemberAllocations: IActionRemoveCrisisCallTeamMemberAllocations = action(
  (state, { allocationClientIds }) => {
    const allocationClientIdsSet = new Set(allocationClientIds);

    state.crisisCallTeamMembers.forEach(member => {
      removeAllocations(member, allocation => {
        const allocationClientId = getAllocationClientId(allocation);

        return allocationClientId != null && allocationClientIdsSet.has(allocationClientId);
      });
    });
  },
);

export default removeCrisisCallTeamMemberAllocations;
